import { removeItem } from "@/helpers/persistanceStorage";
import axios from "@/api/axios";

const mutations = {
  logout(state) {
    state.isLoggedIn = false;
    state.currentUser = null;
  },
};
const actions = {
  logout(context) {
    return new Promise(() => {
      removeItem("accessToken");
      delete axios.defaults.headers.common["Authorization"];
      context.commit("logout");
    });
  },
};

export default {
  actions,
  mutations,
};
